<template>
	<div>
		<div class="data7">
			<div class="data7Til">{{list.data.menuTitle}}</div>
			<div class="data7Box">
				<div class="data7BoxFor" v-for="(item,index) in list.data.content" :key="index">
					<div class="data7ForImg">
						<img :src="item.cover" />
					</div>
					<div class="data7ForName">
						{{item.title}}
					</div>
					<div class="data7ForCen">
						<div v-for="(itema,indexa) in item.desc" :key="indexa">{{itema.text}}</div>
					</div>
				</div>
			</div>
			<div class="data7Img" :style="{
				paddingRight:bj+'px'
			}">
				<div class="swiper-data2-banner" :class="`swiper-data2-banner${list.index}`">
					<div class="swiper-wrapper">
						<div class="swiper-slide" v-for="(item,index) in list.data.cover" :key="index">
							<img :src="item" />

						</div>
					</div>
					<template v-if="!headerShow">
							<div class="swiper-hexin-prev"  :style="{
								left:`30px`,
								display:qhShow?activeIndex==0?'none':'block':'none'
							}" @click="prev()">
								<img src="@/assets/index/hxz.png" />
							</div>
							<div class="swiper-hexin-next" :style="{
								right:`30px`,
								display:qhShow?activeIndex==list.data.cover.length-1?'none':'block':'none'
							}" @click="next()">
								<img src="@/assets/index/hxy.png" />
							</div>
						</template>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {

		},
		data() {
			return {
				jqsjList: [{
						img: require('@/assets/product/page2/jjql.png'),
						name: '简洁轻量',
						cen: '重量轻、体积小，便于搬运使用节约空间，可直接放置于台车上'
					},
					{
						img: require('@/assets/product/page2/kcxbt.png'),
						name: '可拆卸泵头',
						cen: '泵头可拆卸式设计，组装简单，使用方便可轻松适应不同应用场景'
					},
				],
				bj: '',
				qhShow:true,
				activeIndex: 0,
			}
		},
		props: {
			list: {
				typeof: Object,
				default: {}
			}
		},
		mounted() {
			let t = this;
			this.getWidth();
			// autoplay: {
			// 	delay: 3000,
			// 	disableOnInteraction: false,
			// },
			let name = '.swiper-data2-banner' + this.list.index;
			const mySwiper = new this.$swiper(name, {
				// 方向
				direction: 'horizontal',
				// 自动播放
				autoplay: false,
				allowTouchMove: this.list.data.cover.length > 1 ? true : false,
				on: {
					slideChangeTransitionStart(e) {
						t.activeIndex = this.activeIndex;
					},

				},
			});
			this.$nextTick(function(){
				if(this.list.data.cover.length<2){
					this.qhShow=false
				}
			})
		},
		methods: {
			getWidth() {
				console.log(document.body.clientWidth, window.screen.availWidth)
				let width = ''
				if (document.body.clientWidth > 1200) {
					width = document.body.clientWidth - 1200;
				} else {
					width = 0;
				}
				this.$nextTick(function() {
					this.bj = width / 2
				})
			},
			next(){
				console.log("right")
				let t=this;
				if(t.activeIndex==t.list.data.cover.length-1){
					t.activeIndex = 0;
				}else{
					t.activeIndex++;
				}
				// this.mySwiper.slideNext()
			},
			prev(){
				let t=this;
				if(t.activeIndex==0){
					t.activeIndex = t.list.data.cover.length-1;
				}else{
					t.activeIndex--;
				}
				console.log("left")
				// this.mySwiper.slidePrev()
			},
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.swiper-data2-banner {
		overflow: hidden;
		position: relative;
		.swiper-hexin-prev{
			display: none;
		}
		.swiper-hexin-next{
			display: none;
		}
	}

	.swiper-slide {
		position: relative;

		img {
			width: 50vw;
			height: 600px;
			object-fit: cover;
		}

		video {
			width: 50vw;
			height: 600px;
		}
	}

	.data7 {
		padding-bottom: 150px;

		.data7Til {
			font-size: 45px;
			
			font-weight: bold;
			color: #000000;
			width: 1200px;
			margin: 0 auto 40px;
			// padding-left: 200px;
			// margin-bottom: 69px;
		}

		.data7Box {
			// padding:0 200px;
			width: 1200px;
			margin: 0 auto;
			display: flex;
			flex-wrap: wrap;

			.data7BoxFor {
				width: 251px;
				padding: 0 10px;
				margin-bottom: 60px;

				.data7ForImg {
					margin-bottom: 35px;

					>img {
						width: 70px;
						height: 70px;
					}
				}

				.data7ForName {
					font-size: 26px;
					
					font-weight: 400;
					color: #000000;
					margin-bottom: 35px;
				}

				.data7ForCen {
					font-size: 18px;
					
					font-weight: 300;
					color: #000000;

					>div {
						white-space: pre-line;
					}
				}
			}
		}

		.data7Img {
			padding-right: 359px;

			img {
				width: 100%;
				height: 601px;
			}
		}
	}

	@media screen and (max-width:1200px) {
		.swiper-slide {

			img {
				width: 100% !important;
				height: auto !important;
				object-fit: contain;
			}

			video {
				width: 100% !important;
				height: auto !important;
				object-fit: contain;
			}
		}

		.data7 {
			padding:0 30px 30px !important;
			box-sizing: border-box;
			.data7Til {
				font-size: 24px !important;
				width: 100% !important;
				margin: 0 auto 20px !important;
				// padding-left: 200px;
				// margin-bottom: 69px;
			}

			.data7Box {
				// padding:0 200px;
				width: 100% !important;
				margin: 0 auto;
				display: flex;
				flex-wrap: wrap;

				.data7BoxFor {
					width: calc(50% - 20px) !important;
					padding: 0 10px;
					margin-bottom: 20px !important;

					.data7ForImg {
						margin-bottom: 20px !important;

						>img {
							width: 35px !important;
							height: 35px !important;
						}
					}

					.data7ForName {
						font-size: 18px !important;
						margin-bottom: 20px !important;
					}

					.data7ForCen {
						font-size: 14px !important;
					}
				}
			}

			.data7Img {
				padding-right: 0 !important;

				img {
					width: 100%;
					height: auto !important;
					object-fit: contain !important;  
				}
			}
		}
		.swiper-data2-banner{
			.swiper-hexin-prev{
				display: block;
			}
			.swiper-hexin-next{
				display: block;
			}
			.swiper-hexin-prev {
				position: absolute;
				top: 50%;
				left: 250px;
				z-index: 99;
				width: 48px;
				height: 48px;
				cursor: pointer;
				img {
					width: 14px !important;
					height: 24px !important;
				}
			
				display: flex;
				align-items: center;
				justify-content: center;
				border-radius: 100%;
				transform: translateY(-50%);
				transition: all 0.3s ease;
			}
			
			.swiper-hexin-next {
				transform: translateY(-50%);
				position: absolute;
				top: 50%;
				right: 250px;
				z-index: 99;
				width: 48px;
				height: 48px;
				border-radius: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
				transition: all 0.3s ease;
				cursor: pointer;
				img {
					width: 14px !important;
					height: 24px !important;
				}
			}
		}
	}
</style>